/**
 * FIFA 2026 page — countdown ticker + match schedule interaction.
 *
 * Loaded automatically by lib/setup.php::vp_contextual_template_assets()
 * when the active page template is page-fifa2026.php.
 */

(function ($) {
    "use strict";

    // ---------------------------------------------------------
    // Tournament countdown
    // ---------------------------------------------------------
    function initCountdown() {
        var $cd = $(".fifa-countdown");
        if (!$cd.length) return;

        var raw = $cd.attr("data-fifa-countdown");
        if (!raw) return;

        var cfg;
        try { cfg = JSON.parse(raw); } catch (e) { return; }

        var openMs = Date.parse(cfg.openIso);
        if (isNaN(openMs)) return;

        var matchDurationMs = (cfg.matchDurationMinutes || 130) * 60 * 1000;
        var schedule = (cfg.schedule || []).slice().sort(function (a, b) {
            return Date.parse(a.kickoff) - Date.parse(b.kickoff);
        });

        var $heading = $cd.find("[data-fifa-countdown-heading]");
        var $message = $cd.find("[data-fifa-countdown-message]");
        var $days    = $cd.find('.fifa-countdown__num[data-fifa-countdown-value="days"]');
        var $hours   = $cd.find('.fifa-countdown__num[data-fifa-countdown-value="hours"]');
        var $mins    = $cd.find('.fifa-countdown__num[data-fifa-countdown-value="minutes"]');
        var $secs    = $cd.find('.fifa-countdown__num[data-fifa-countdown-value="seconds"]');
        var defaultHeading = cfg.headingDefault || "Tournament Countdown";
        // Staggered split-flap. Top folds down to reveal pre-loaded
        // NEW; bottom flap drops in carrying NEW; static-bottom is
        // silently swapped at the very end while covered by the flap.
        //   phase 1 (0–50%):    top flap folds down  (rotateX 0 → -90°)
        //   phase 2 (50–100%):  bottom flap drops in (rotateX 90° → 0°)
        //
        // Production timing. To debug, set FLIP_DURATION_MS = 10000 and
        // SLOW_FACTOR = 10 (and bump the matching CSS animation values).
        // Must match the CSS animation durations + delays.
        var FLIP_DURATION_MS = 800;
        var SLOW_FACTOR      = 1;

        // Debug preview: ?fifa_now=DATE overrides "now" so you can
        // preview a future phase (between matches, live match,
        // post-tournament). The countdown still TICKS from the
        // overridden moment, so you can watch phase transitions.
        //
        // All times are interpreted as Philly local time (EDT) unless
        // a timezone is given. Friendly formats supported:
        //   ?fifa_now=2026-07-05               → midnight Philly time
        //   ?fifa_now=2026-06-25T16:30         → 4:30 PM Philly time
        //   ?fifa_now=2026-06-25T16:30:00-04:00 → full ISO still works
        var FIFA_NOW_OVERRIDE = (function () {
            var m = window.location.search.match(/[?&]fifa_now=([^&]+)/);
            if (!m) return null;
            var s = decodeURIComponent(m[1]).trim();
            // Full ISO with explicit timezone → parse as-is.
            if (/Z$|[+\-]\d{2}:?\d{2}$/.test(s)) {
                var t1 = Date.parse(s);
                return isNaN(t1) ? null : t1;
            }
            // Friendly form: YYYY-MM-DD with optional [T ]HH:MM[:SS],
            // interpreted as Philly EDT (-04:00). The FIFA window
            // (Jun 11 – Jul 19, 2026) is entirely inside DST.
            var p = s.match(/^(\d{4}-\d{2}-\d{2})(?:[ T](\d{1,2}):(\d{2})(?::(\d{2}))?)?$/);
            if (!p) return null;
            var hh = ('0' + (p[2] || '0')).slice(-2);
            var mm = p[3] || '00';
            var ss = p[4] || '00';
            var t2 = Date.parse(p[1] + 'T' + hh + ':' + mm + ':' + ss + '-04:00');
            return isNaN(t2) ? null : t2;
        })();
        var realStartMs = Date.now();
        function effectiveNow() {
            if (FIFA_NOW_OVERRIDE === null) return Date.now();
            // Tick forward from the fake moment using real elapsed time.
            return FIFA_NOW_OVERRIDE + (Date.now() - realStartMs);
        }

        var clockStartMs   = effectiveNow();
        var clockStartDiff = openMs - clockStartMs;
        function slowDiff() {
            if (SLOW_FACTOR === 1) return openMs - effectiveNow();
            var elapsed = effectiveNow() - clockStartMs;
            return clockStartDiff - (elapsed / SLOW_FACTOR);
        }

        function setPhase(name) {
            $cd.removeClass("is-phase-pre is-phase-next is-phase-live is-phase-after");
            $cd.addClass("is-phase-" + name);
        }

        // Split-flap flip. The critical bit is that at every visible
        // moment, the top and bottom halves must show the SAME digit.
        //
        //  Phase 1 (T=0 → 500ms):
        //    flip-top is visible, showing OLD, rotating 0° → -90°.
        //    static-top is covered by flip-top, holds OLD.
        //    static-bottom is visible, holds OLD.
        //    → User sees OLD on both halves throughout.
        //
        //  Midpoint (T=500ms):
        //    Both flap halves at ±90° (perpendicular, foreshortened to ~0px).
        //    JS swaps static-top AND static-bottom to NEW simultaneously.
        //    User's eye is on the moving flaps, not the static layer.
        //
        //  Phase 2 (T=500 → 1000ms):
        //    flip-bottom is visible, showing NEW, rotating 90° → 0°.
        //    static-top is visible (revealed after flip-top folded), holds NEW.
        //    static-bottom is being covered by flip-bottom, both NEW.
        //    → User sees NEW on both halves throughout.
        function flipDigit($num, newVal) {
            var newStr = String(newVal);
            var $staticTop    = $num.find(".fifa-countdown__num-half--top         .fifa-countdown__num-inner");
            var $staticBottom = $num.find(".fifa-countdown__num-half--bottom      .fifa-countdown__num-inner");
            var $flipTop      = $num.find(".fifa-countdown__num-half--flip-top    .fifa-countdown__num-inner");
            var $flipBottom   = $num.find(".fifa-countdown__num-half--flip-bottom .fifa-countdown__num-inner");

            var oldStr = $staticTop.text();
            if (oldStr === newStr) return;

            // Staggered split-flap. Flap halves carry OLD (top, fading
            // out) and NEW (bottom, dropping in). Static halves get
            // swapped to NEW behind the opaque flap, so the flap's
            // fade-out reveals NEW underneath without any snap.
            $flipTop.text(oldStr);     // covers static-top, shows OLD until it folds
            $flipBottom.text(newStr);  // drops in during phase 2 showing NEW
            // statics intentionally NOT touched yet — they get updated
            // by the timers below, AFTER the flap is fully opaque, so
            // the user never sees the static swap.

            // Clear pending timeouts from a prior flip on this digit.
            var pending = $num.data("fifa-flip-timeouts");
            if (pending && pending.length) {
                for (var i = 0; i < pending.length; i++) clearTimeout(pending[i]);
            }

            $num.removeClass("is-flipping");
            void $num[0].offsetWidth; // restart keyframes
            $num.addClass("is-flipping");

            // Three timers — both static swaps happen in the OPAQUE
            // window of their respective flap, so the swap is hidden:
            //   midTopTimer    @ 10% — flap-top is fully opaque
            //                          (past the 5% fade-in), well
            //                          before its 95% fade-out. Swap
            //                          static-top so the fade-out
            //                          reveals NEW already in place.
            //   midBottomTimer @ 75% — deep in phase 2's opaque window,
            //                          well before flip-bottom's 5%
            //                          fade-out. Swap static-bottom so
            //                          the fade-out reveals NEW.
            //   endTimer       @ end — clean up, drop is-flipping.
            var midTopTimer = setTimeout(function () {
                $staticTop.text(newStr);
            }, Math.round(FLIP_DURATION_MS * 0.10));

            var midBottomTimer = setTimeout(function () {
                $staticBottom.text(newStr);
            }, Math.round(FLIP_DURATION_MS * 0.75));

            var endTimer = setTimeout(function () {
                $num.removeClass("is-flipping");
            }, FLIP_DURATION_MS + 20);

            $num.data("fifa-flip-timeouts", [midTopTimer, midBottomTimer, endTimer]);
        }

        function paint(diffMs) {
            if (diffMs < 0) diffMs = 0;
            var s = Math.floor(diffMs / 1000);
            var d = Math.floor(s / 86400); s -= d * 86400;
            var h = Math.floor(s / 3600);  s -= h * 3600;
            var m = Math.floor(s / 60);    s -= m * 60;
            flipDigit($days,  d);
            flipDigit($hours, h);
            flipDigit($mins,  m);
            flipDigit($secs,  s);
        }

        function tick() {
            var now = effectiveNow();

            // Phase 1 — pre-tournament: count down to opening match.
            if (now < openMs) {
                $heading.text(defaultHeading);
                $message.hide().attr("hidden", true);
                setPhase("pre");
                paint(slowDiff());
                return;
            }

            // Find the current/next Philly match.
            var current = null, next = null;
            for (var i = 0; i < schedule.length; i++) {
                var ko = Date.parse(schedule[i].kickoff);
                if (isNaN(ko)) continue;
                if (now >= ko && now < ko + matchDurationMs) { current = schedule[i]; break; }
                if (now < ko) { next = schedule[i]; break; }
            }

            // Phase 3 — live match window
            if (current) {
                setPhase("live");
                var liveText = cfg.liveMessage || "Match Day in Philadelphia";
                if (current.label) liveText += " — " + current.label;
                $message.text(liveText).removeAttr("hidden").show();
                paint(0);
                return;
            }

            // Phase 2 — between matches: count down to the next Philly match.
            if (next) {
                setPhase("next");
                var nextKo = Date.parse(next.kickoff);
                var headingText = next.label
                    ? "Next Match: " + next.label
                    : (next.dateLabel ? "Next Match: " + next.dateLabel : defaultHeading);
                $heading.text(headingText);
                $message.hide().attr("hidden", true);
                paint(nextKo - now);
                return;
            }

            // Phase 4 — post-tournament
            setPhase("after");
            $message.text(cfg.afterMessage || "Thanks for a historic tournament.").removeAttr("hidden").show();
            paint(0);
        }

        tick();
        setInterval(tick, 1000);
    }

    // ---------------------------------------------------------
    // Match schedule interaction (tablist pattern, mirrors VPOHP)
    // ---------------------------------------------------------
    function initSchedule() {
        var $schedule = $(".fifa-schedule");
        if (!$schedule.length) return;

        var $items = $schedule.find(".fifa-schedule__item");
        var $details = $schedule.find(".fifa-schedule__detail-item");
        var $detailsContainer = $schedule.find(".fifa-schedule__details");
        var $nav = $schedule.find(".fifa-schedule__nav");
        var $prevBtn = $schedule.find(".fifa-schedule__nav-prev");
        var $nextBtn = $schedule.find(".fifa-schedule__nav-next");
        var totalItems = $items.length;
        if (!totalItems) return;
        var currentIndex = 0;
        var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

        $items.attr("role", "tab");
        $details.attr("role", "tabpanel");
        $schedule.find(".fifa-schedule__items").attr("role", "tablist");
        $detailsContainer.attr("aria-live", "polite");

        $items.each(function (i) {
            var $item = $(this);
            var isActive = $item.hasClass("is-active");
            $item.attr({
                "aria-selected": isActive,
                "aria-controls": "fifa-detail-" + i
            });
            $details.eq(i).attr("id", "fifa-detail-" + i);
        });

        var isAnimating = false;

        function activate(index) {
            if (isAnimating) return;
            if (index < 0) index = totalItems - 1;
            if (index >= totalItems) index = 0;
            if (index === currentIndex) return;

            isAnimating = true;
            var $currentDetail = $details.eq(currentIndex);
            var $nextDetail = $details.eq(index);

            currentIndex = index;

            $items.attr("aria-selected", "false");
            $items.eq(index).attr("aria-selected", "true");
            $items.removeClass("is-active");
            $items.eq(index).addClass("is-active");

            if (prefersReducedMotion) {
                $currentDetail.removeClass("is-active");
                $nextDetail.addClass("is-active");
                isAnimating = false;
            } else {
                $nav.addClass("is-transitioning");
                $currentDetail.addClass("is-animating-out");
                $nextDetail.addClass("is-active is-animating-in");

                setTimeout(function () {
                    $currentDetail.removeClass("is-active is-animating-out");
                    $nextDetail.removeClass("is-animating-in");
                    isAnimating = false;
                }, 400);

                setTimeout(function () {
                    $nav.removeClass("is-transitioning");
                }, 550);
            }

            if (window.innerWidth < 700) {
                var scrollTarget = $detailsContainer.offset().top - 60;
                window.scrollTo({
                    top: scrollTarget,
                    behavior: prefersReducedMotion ? "auto" : "smooth"
                });
            }
        }

        $items.on("click", function () {
            var index = $(this).data("item-index");
            var matchName = $.trim($(this).find(".fifa-schedule__item-title").text());
            if (window.VP && VP.helpers && typeof VP.helpers.firecustomGTMEvent === "function") {
                VP.helpers.firecustomGTMEvent("click_fifa_match", matchName);
            }
            activate(index);
        });

        $items.attr("tabindex", "0").on("keydown", function (e) {
            var index = $(this).data("item-index");
            switch (e.key) {
                case "Enter":
                case " ":
                    e.preventDefault();
                    activate(index);
                    break;
                case "ArrowDown":
                case "ArrowRight":
                    e.preventDefault();
                    activate(index + 1);
                    $items.eq(currentIndex).focus();
                    break;
                case "ArrowUp":
                case "ArrowLeft":
                    e.preventDefault();
                    activate(index - 1);
                    $items.eq(currentIndex).focus();
                    break;
                case "Home":
                    e.preventDefault();
                    activate(0);
                    $items.eq(0).focus();
                    break;
                case "End":
                    e.preventDefault();
                    activate(totalItems - 1);
                    $items.eq(totalItems - 1).focus();
                    break;
            }
        });

        $prevBtn.on("click", function () { activate(currentIndex - 1); });
        $nextBtn.on("click", function () { activate(currentIndex + 1); });
    }

    $(function () {
        initCountdown();
        initSchedule();
    });
})(jQuery);
